module.exports = __webpack_public_path__ + "static/img/energy-h5.8ee4476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/energy-h5.png
// module id = V0ZH
// module chunks = 34